import usePropertiesUpdatingAllowed from 'components/domain/property/usePropertiesUpdatingAllowed';
import NotFound from '../notFound/NotFound';
import { Container } from './OwnerAdjustments.styles';
import OwnerAdjustmentsHeader from './header/OwnerAdjustmentsHeader';
import OneTimeAdjustmentsTable from './tables/OneTimeAdjustmentsTable';
import RecurringAdjustmentsTable from './tables/RecurringAdjustmentsTable';

const OwnerAdjustments = () => {
  const propertiesUpdatingAllowed = usePropertiesUpdatingAllowed();

  if (!propertiesUpdatingAllowed) {
    return <NotFound />;
  }

  return (
    <Container>
      <OwnerAdjustmentsHeader />
      <RecurringAdjustmentsTable />
      <OneTimeAdjustmentsTable />
    </Container>
  );
};

export default OwnerAdjustments;
